import { InviteFormFields, InviteFormFieldsValues, InviteFormFieldsValuesForStaff } from './types';

export const emptyStaffObject: InviteFormFieldsValuesForStaff = {
  email: '',
};

export const initialValues: InviteFormFieldsValues = {
  [InviteFormFields.staff]: [emptyStaffObject],
};
